module.exports = __webpack_public_path__ + "img/item-factory.5f918e37.svg";